var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable babel/new-cap */
import { Vue, Component } from 'vue-property-decorator';
import ColorfulParagraph from './pages/colorful-paragraph.vue';
import Home from './pages/Home.vue';
import { throttle } from 'throttle-debounce';
import { Mutation } from 'vuex-class';
let App = class App extends Vue {
    constructor() {
        super(...arguments);
        this.isPC = window.isPC || false;
        this.iframeWidth = 0;
        this.h = 0;
        this.w = 0;
    }
    get inPcStyle() {
        return {
            width: `${this.iframeWidth}px`,
        };
    }
    mounted() {
        if (this.isPC) {
            this.dynamicInsertDom(); // 加入头文件
            const resizeFn = () => {
                this.h = this.getWindowH();
                this.w = this.getWindowW();
                this.iframeWidth = (375 * (this.h - 56)) / 667;
                this.SET_HEIGHT(this.h - 56);
                this.SET_WIDTH(this.iframeWidth);
                window.document.documentElement.style.fontSize = this.getRootSize();
                window.document.body.classList.add('pc-mode');
            };
            resizeFn();
            this.resizeHandler = throttle(16, false, resizeFn);
            window.addEventListener('resize', this.resizeHandler, false);
        }
        else {
            const h = this.getWindowH();
            this.SET_CLIENT_HEIGHT(h);
        }
    }
    dynamicInsertDom() {
        const header = document.createElement('div');
        header.id = 'biliMainHeader';
        document.body.insertBefore(header, document.body.childNodes[0]);
        const sc = document.createElement('script');
        sc.type = 'text/javascript';
        sc.src = '//s1.hdslb.com/bfs/seed/jinkela/header-v2/header.js';
        document.body.appendChild(sc);
    }
    getRootSize() {
        const design = 750;
        const font = 100;
        const ratio = design / font;
        let result = '';
        if (this.iframeWidth > design) {
            result = '100px';
        }
        else {
            result = `${this.iframeWidth / ratio}px`;
        }
        return result;
    }
    getWindowW() {
        return window.innerWidth || window.document.documentElement.clientWidth || window.screen.width;
    }
    getWindowH() {
        return window.innerHeight || document.documentElement.clientHeight || window.screen.height;
    }
};
__decorate([
    Mutation
], App.prototype, "SET_CLIENT_HEIGHT", void 0);
__decorate([
    Mutation
], App.prototype, "SET_HEIGHT", void 0);
__decorate([
    Mutation
], App.prototype, "SET_WIDTH", void 0);
App = __decorate([
    Component({
        metaInfo() {
            return {
                title: '2020年度追番报告',
            };
        },
        components: {
            ColorfulParagraph,
            Home,
        },
    })
], App);
export default App;
